import { render } from "./TourDetailsView.vue?vue&type=template&id=5eee0586"
import script from "./TourDetailsView.vue?vue&type=script&lang=js"
export * from "./TourDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__